<div class="mr-page">
  <div class="mr-header">
    <div class="mr-header__identity">
      <div class="mr-header__titles">
        <h5 class="mb-0">Reporte mensual de conectividad</h5>
        <small class="text-muted" *ngIf="displayHeader">
          {{ headerSubtitle(displayHeader) }}
        </small>
        <small class="text-muted" *ngIf="!displayHeader && serviceState === 'loading'">
          Cargando institución…
        </small>
      </div>
    </div>

    <div class="mr-header__controls" *ngIf="serviceState === 'ready'">
      <div class="mr-period">
        <div class="mr-month">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            [disabled]="!canGoPrev"
            (click)="goPrevMonth()"
            aria-label="Mes anterior"
          >
            <i class="feather icon-chevron-left"></i>
          </button>
          <select
            class="form-select form-select-sm mr-month__select"
            [ngModel]="yearMonth"
            (ngModelChange)="onMonthSelect($event)"
            aria-label="Mes del reporte"
          >
            <option *ngFor="let option of monthOptions" [value]="option.value">{{ option.label }}</option>
          </select>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            [disabled]="!canGoNext"
            (click)="goNextMonth()"
            aria-label="Mes siguiente"
          >
            <i class="feather icon-chevron-right"></i>
          </button>
        </div>

        <span
          class="badge mr-period-badge"
          *ngIf="report"
          [class.mr-period-badge--closed]="report.periodStatus === 'CLOSED'"
          [class.mr-period-badge--preliminary]="report.periodStatus === 'PRELIMINARY'"
        >
          {{ report.periodStatus === 'CLOSED' ? 'CERRADO' : 'PRELIMINAR' }}
        </span>
      </div>

      <span class="mr-pdf d-inline-block" [ngbTooltip]="pdfTooltip" container="body">
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary mr-pdf__btn"
          [disabled]="!canDownloadPdf || generatingPdf"
          (click)="downloadPdf()"
        >
          <i class="feather icon-download"></i>
          {{ generatingPdf ? 'Generando PDF...' : 'Descargar PDF' }}
        </button>
      </span>
    </div>
  </div>

  <p class="text-muted small mr-period-hint" *ngIf="report?.periodStatus === 'PRELIMINARY'">
    El mes aún está en curso. Los datos pueden variar hasta el cierre.
  </p>

  <div
    class="alert alert-danger d-flex justify-content-between align-items-center"
    *ngIf="serviceState === 'error'"
  >
    <span>{{ serviceError?.message }}</span>
    <button
      type="button"
      class="btn btn-sm btn-outline-danger"
      *ngIf="serviceError?.retryable"
      (click)="retryService()"
    >
      Reintentar
    </button>
  </div>

  <div class="mr-empty mr-empty--compact" *ngIf="serviceState === 'empty'">
    <i class="feather icon-info"></i>
    <p class="mb-0">{{ emptyServicesMessage }}</p>
  </div>

  <div class="mr-empty mr-empty--compact" *ngIf="serviceState === 'many'">
    <i class="feather icon-info"></i>
    <p class="mb-0">{{ manyServicesMessage }}</p>
  </div>

  <ng-container *ngIf="serviceState === 'ready'">
    <app-card [hidHeader]="true" cardClass="mb-3" *ngIf="displayHeader">
      <div class="row g-3">
        <div class="col-6 col-md-3">
          <div class="mr-field">
            <span class="mr-field__label">Código modular</span>
            <span class="mr-field__value">{{ displayHeader.modularCode || '—' }}</span>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="mr-field">
            <span class="mr-field__label">UGEL</span>
            <span class="mr-field__value">{{ displayHeader.ugel || '—' }}</span>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="mr-field">
            <span class="mr-field__label">Localidad</span>
            <span class="mr-field__value">{{ localityLabel(displayHeader) }}</span>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="mr-field">
            <span class="mr-field__label">Plan contratado</span>
            <span class="mr-field__value">{{ planLabel(displayHeader) }}</span>
          </div>
        </div>
      </div>
    </app-card>

    <div
      class="alert alert-danger d-flex justify-content-between align-items-center"
      *ngIf="reportState === 'error'"
    >
      <span>{{ error?.message }}</span>
      <button
        type="button"
        class="btn btn-sm btn-outline-danger"
        *ngIf="error?.retryable"
        (click)="retry()"
      >
        Reintentar
      </button>
    </div>

    <ng-container *ngIf="reportState === 'loading'">
      <app-card [hidHeader]="true" cardClass="mb-3">
        <p class="text-muted small mb-3">Cargando {{ monthLabel }}…</p>
        <div class="mr-kpis">
          <div class="mr-kpi mr-kpi--hero placeholder-glow">
            <span class="placeholder col-6"></span>
            <span class="placeholder col-8 mt-2 mr-skeleton-value"></span>
          </div>
          <div class="mr-kpis__side">
            <div class="mr-kpi placeholder-glow" *ngFor="let slot of skeletonSlots">
              <span class="placeholder col-7"></span>
              <span class="placeholder col-8 mt-2 mr-skeleton-value"></span>
            </div>
          </div>
        </div>
      </app-card>
      <app-card [hidHeader]="true" cardClass="mb-3">
        <div class="placeholder-glow">
          <span class="placeholder col-4 mb-3"></span>
          <span class="placeholder col-12 mr-skeleton-chart"></span>
        </div>
      </app-card>
      <app-card [hidHeader]="true" cardClass="mb-3">
        <div class="placeholder-glow">
          <span class="placeholder col-3 mb-3"></span>
          <span class="placeholder col-12"></span>
          <span class="placeholder col-12 mt-2"></span>
        </div>
      </app-card>
    </ng-container>

    <ng-container *ngIf="reportState === 'ready' && report">
      <app-card [hidHeader]="true" cardClass="mb-4">
        <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
          <h6 class="mb-0">Resumen del período</h6>
          <span class="badge bg-warning text-dark" *ngIf="report.traffic.dataStatus === 'PARTIAL'">
            Datos parciales
          </span>
        </div>

        <div class="mr-kpis">
          <div class="mr-kpi mr-kpi--hero h-100">
            <span class="mr-kpi__label"><i class="feather icon-activity"></i> Disponibilidad</span>
            <ng-container [ngSwitch]="report.availability.status">
              <span class="mr-kpi__value" *ngSwitchCase="'COMPLETE'">
                {{ availabilityPercentLabel }}
              </span>
              <span class="mr-kpi__state" *ngSwitchCase="'INCOMPLETE'">
                Disponibilidad no calculable
              </span>
              <span class="mr-kpi__state" *ngSwitchDefault>
                Información de disponibilidad no disponible
              </span>
            </ng-container>
            <span class="mr-kpi__hint" *ngIf="report.availability.status === 'INCOMPLETE'">
              {{ incompleteAvailabilityHint }}
            </span>
          </div>

          <div class="mr-kpis__side">
            <div class="mr-kpi h-100">
              <span class="mr-kpi__label"><i class="feather icon-arrow-down"></i> Descarga total</span>
              <span class="mr-kpi__value">{{ formatBytes(report.traffic.monthlyKpis?.downloadBytes) }}</span>
            </div>
            <div class="mr-kpi h-100">
              <span class="mr-kpi__label"><i class="feather icon-arrow-up"></i> Subida total</span>
              <span class="mr-kpi__value">{{ formatBytes(report.traffic.monthlyKpis?.uploadBytes) }}</span>
            </div>
            <div class="mr-kpi h-100">
              <span class="mr-kpi__label"><i class="feather icon-trending-down"></i> Pico de bajada</span>
              <span class="mr-kpi__value">{{ formatMbps(report.traffic.monthlyKpis?.downloadMaxMbps) }}</span>
            </div>
            <div class="mr-kpi h-100">
              <span class="mr-kpi__label"><i class="feather icon-trending-up"></i> Pico de subida</span>
              <span class="mr-kpi__value">{{ formatMbps(report.traffic.monthlyKpis?.uploadMaxMbps) }}</span>
            </div>
          </div>
        </div>

        <p class="text-muted small mb-0 mt-3" *ngIf="trafficNote">{{ trafficNote }}</p>
        <p class="text-muted small mb-0 mt-3">{{ availabilitySourceNote }}</p>
      </app-card>

      <app-card [hidHeader]="true" cardClass="mb-4">
        <h6 class="mb-1">Comportamiento del tráfico</h6>
        <p class="text-muted small mb-3">{{ monthLabel }}</p>

        <ng-container *ngIf="chart as dailyChart; else dailyEmpty">
          <apx-chart
            #monthlyReportChart
            [series]="dailyChart.series"
            [chart]="dailyChart.chart"
            [xaxis]="dailyChart.xaxis"
            [yaxis]="dailyChart.yaxis"
            [stroke]="dailyChart.stroke"
            [dataLabels]="dailyChart.dataLabels"
            [colors]="dailyChart.colors"
            [legend]="dailyChart.legend"
            [tooltip]="dailyChart.tooltip"
            [grid]="dailyChart.grid"
            [markers]="dailyChart.markers"
          ></apx-chart>
        </ng-container>
        <ng-template #dailyEmpty>
          <div class="mr-empty">
            <i class="feather icon-bar-chart-2"></i>
            <p class="mb-0">Sin datos de tráfico para este período.</p>
          </div>
        </ng-template>
      </app-card>

      <app-card [hidHeader]="true" cardClass="mb-3">
        <h6 class="mb-3">Incidentes del mes</h6>

        <div class="table-responsive" *ngIf="report.incidents.length; else incidentsEmpty">
          <table class="table table-sm mr-table mb-0">
            <thead>
              <tr>
                <th class="mr-table__code">Código</th>
                <th class="mr-table__period">Período</th>
                <th class="mr-table__type">Tipo</th>
                <th class="mr-table__desc">Descripción</th>
                <th class="mr-table__duration">Duración</th>
                <th class="mr-table__status">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let incident of report.incidents">
                <td class="mr-table__code">
                  <ng-container *ngIf="incidentCode(incident.code) as code">
                    <span class="fw-bold text-primary" *ngIf="code !== '—'; else portalCodeEmpty">{{ code }}</span>
                    <ng-template #portalCodeEmpty>—</ng-template>
                  </ng-container>
                </td>
                <td class="mr-table__period">{{ incidentPeriod(incident) }}</td>
                <td class="mr-table__type">{{ categoryLabel(incident.category) }}</td>
                <td class="mr-table__desc">{{ incident.subject || '—' }}</td>
                <td class="mr-table__duration">{{ durationLabel(incident.clippedDurationSeconds) }}</td>
                <td class="mr-table__status">
                  <app-ticket-status-badge
                    *ngIf="incident.status; else portalStatusEmpty"
                    type="status"
                    [color]="statusColor(incident.status)"
                    [label]="statusLabel(incident.status)"
                  ></app-ticket-status-badge>
                  <ng-template #portalStatusEmpty>—</ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #incidentsEmpty>
          <div class="mr-empty mr-empty--compact">
            <i class="feather icon-check-circle"></i>
            <p class="mb-0">Sin incidentes registrados durante el período.</p>
          </div>
        </ng-template>
      </app-card>
    </ng-container>

    <!-- Renderizado específico para captura de alta resolución en PDF -->
    <div
      *ngIf="pdfChart"
      class="mr-pdf-chart-offscreen"
      style="position: fixed; left: -9999px; top: -9999px; width: 960px; height: 360px; overflow: hidden; pointer-events: none; opacity: 0;"
      aria-hidden="true"
    >
      <apx-chart
        #pdfMonthlyReportChart
        [series]="pdfChart.series"
        [chart]="pdfChart.chart"
        [xaxis]="pdfChart.xaxis"
        [yaxis]="pdfChart.yaxis"
        [stroke]="pdfChart.stroke"
        [dataLabels]="pdfChart.dataLabels"
        [colors]="pdfChart.colors"
        [legend]="pdfChart.legend"
        [tooltip]="pdfChart.tooltip"
        [grid]="pdfChart.grid"
        [markers]="pdfChart.markers"
      ></apx-chart>
    </div>
  </ng-container>
</div>
